/** Shared list filter helpers for Locations / Accounts server lists. */

export const flattenFiltersForApi = (filtersByField) => {
  const list = [];
  Object.entries(filtersByField || {}).forEach(([field, colFilter]) => {
    if (!colFilter?.filters?.length) return;
    const active = colFilter.filters.filter((f) => {
      if (f.operator === 'isempty' || f.operator === 'isnotempty') return true;
      return String(f.value ?? '').trim() !== '';
    });
    active.forEach((f, idx) => {
      list.push({
        Field: field,
        Operator: f.operator,
        Value: f.value ?? '',
        Logic: idx === 0 ? 'and' : (colFilter.logic || 'and'),
      });
    });
  });
  return list;
};
